import { useLocation } from "react-router-dom";
import { contactUsHooks } from ".."
import { replaceId } from "utils/formatter";


const useSubmitBtns = () => {
    const submitBtn = contactUsHooks.useSubmitBtn()
    const setAlert = contactUsHooks.useAlert()
    const cleanForm = contactUsHooks.useCleanForm()

    const submitBtns = [
        {
            ...submitBtn,
            color: "thirdly",
            fullWidth: false,
            action: async () => {
                const data = await submitBtn.action()
                if (data)
                    setAlert(false)
            }
        },
        {
            action: cleanForm,
            label: "ניקוי",
            color: "thirdly4"
        }
    ]

    return submitBtns
}

export default useSubmitBtns